import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from '../../core/service'

export const getTotalSeperateCompanies = createAsyncThunk(
  'portfolio/summary/getTotalSeperateCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTotalSeperateCompanies()
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
